// Human labels for the AI provenance vfs-service records (see vfs-service provenance contract, section 1).

export const ACTION_LABELS = {
  create: 'Created',
  edit: 'Edited files',
  scaffold: 'Scaffolded',
  upload: 'Uploaded',
  import: 'Imported',
  clone: 'Cloned',
  'git-push': 'Pushed to git',
  'git-pull': 'Pulled from git',
  'git-fetch': 'Fetched from git',
  preview: 'Preview',
  publish: 'Published',
  'quality-override': 'Published past the quality gate',
  deploy: 'Deployed',
  share: 'Shared',
  'chat-turn': 'Chat turn',
  compacted: 'Compacted',
};

export const KEY_SOURCE_LABELS = {
  'org-gateway': 'Organization key (AI gateway)',
  'org-direct': 'Organization key',
  'own-key': 'Own key',
  'tool-own': "Tool's own model",
  unknown: 'Unknown key',
  none: 'No AI',
};

// Short form for the timeline and the model rows.
export const KEY_SOURCE_SHORT = {
  'org-gateway': 'Org key',
  'org-direct': 'Org key',
  'own-key': 'Own key',
  'tool-own': 'Tool',
};

export const actionLabel = (action) => ACTION_LABELS[action] || String(action || '');

/** The reason an owner gave to publish past the quality gate (a `quality-override` event), or ''. */
export const overrideReason = (event) => (event?.action === 'quality-override'
  ? String(event.target?.quality?.reason || event.target?.reason || event.reason || '')
  : '');

export const keySourceLabel = (source) => KEY_SOURCE_LABELS[source] || String(source || '');

export const keySourceShort = (source) => KEY_SOURCE_SHORT[source] || (source ? String(source) : '');

export const isOrgKey = (source) => source === 'org-gateway' || source === 'org-direct';

export function modelLabel(entry) {
  if (!entry || !entry.model) { return ''; }
  return entry.provider && entry.provider !== 'unknown' ? `${entry.provider}/${entry.model}` : entry.model;
}

export function clientLabel(client) {
  if (!client) { return ''; }
  return client.label || client.name || client.kind || '';
}

/**
 * Who acted: "You" (or "Flow agent, for you") when it is the signed-in person (`me`, their sub), else the name when
 * known, else a short pseudonym from the hashed email (the record never keeps addresses).
 */
export function actorLabel(actor, me) {
  if (!actor) { return 'Someone'; }
  const mine = Boolean(me && actor.sub && actor.sub === me);
  if (actor.type === 'agent') { return mine ? 'Flow agent, for you' : 'Flow agent'; }
  if (mine) { return 'You'; }
  if (actor.name) { return actor.name; }
  if (actor.type === 'service') { return 'Service'; }
  if (actor.emailHash) { return `Member ${String(actor.emailHash).slice(0, 6)}`; }
  return 'Someone';
}

/** AI actions only: every recorded action but people's own edits without AI. */
export function aiActionCount(summary) {
  if (!summary) { return 0; }
  return Math.max(0, (summary.events || 0) - ((summary.keySources && summary.keySources.none) || 0));
}

/** Own key vs organization key vs external tool, from `summary.keySources`. */
export function keySplit(keySources) {
  const sources = keySources || {};
  const org = (sources['org-gateway'] || 0) + (sources['org-direct'] || 0);
  const own = sources['own-key'] || 0;
  const tool = sources['tool-own'] || 0;
  return { org, own, tool, total: org + own + tool };
}
